export default __webpack_public_path__ + "static/media/element_spec_36.301441bf.webp";